import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "border-b border-slate-200 px-4 py-4 sm:px-5"
};
const _hoisted_2 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_3 = {
  class: "min-w-0"
};
const _hoisted_4 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_5 = {
  class: "min-h-0 flex-1 overflow-y-auto p-4 sm:p-5"
};
const _hoisted_6 = {
  class: "mb-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4"
};
const _hoisted_7 = {
  class: "rounded-md bg-slate-50 p-3"
};
const _hoisted_8 = {
  class: "mt-1 text-base font-semibold text-slate-900"
};
const _hoisted_9 = {
  class: "rounded-md bg-slate-50 p-3"
};
const _hoisted_10 = {
  class: "rounded-md bg-slate-50 p-3"
};
const _hoisted_11 = {
  class: "mt-1 text-base font-semibold text-blue-700"
};
const _hoisted_12 = {
  class: "rounded-md bg-slate-50 p-3"
};
const _hoisted_13 = {
  class: "mt-1 text-base font-semibold text-slate-900"
};
const _hoisted_14 = {
  class: "overflow-hidden rounded-lg border border-slate-200"
};
const _hoisted_15 = {
  class: "border-b border-slate-200 bg-white px-3 py-3"
};
const _hoisted_16 = {
  class: "block"
};
const _hoisted_17 = {
  class: "min-w-[1040px] w-full divide-y divide-slate-200 text-sm"
};
const _hoisted_18 = {
  class: "divide-y divide-slate-100 bg-white"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: "data-table-sticky-left data-table-sticky-identity px-3 py-2.5"
};
const _hoisted_21 = {
  class: "space-y-1.5"
};
const _hoisted_22 = {
  class: "downstream-option-row"
};
const _hoisted_23 = {
  class: "min-w-0 flex-1 truncate font-medium text-slate-800"
};
const _hoisted_24 = {
  class: "downstream-option-meta"
};
const _hoisted_25 = {
  class: "downstream-option-meta"
};
const _hoisted_26 = {
  class: "downstream-option-meta"
};
const _hoisted_27 = {
  class: "downstream-option-meta text-blue-600"
};
const _hoisted_28 = {
  class: "downstream-option-meta"
};
const _hoisted_29 = {
  key: 0,
  class: "grid grid-cols-2 gap-1 rounded-md bg-slate-50 px-2 py-1 text-[11px] leading-4 text-slate-500 md:grid-cols-4"
};
const _hoisted_30 = {
  key: 1,
  class: "text-[11px] leading-4 text-red-600"
};
const _hoisted_31 = {
  class: "px-3 py-2.5 text-xs text-slate-500"
};
const _hoisted_32 = {
  class: "px-3 py-2.5"
};
const _hoisted_33 = ["onUpdate:modelValue"];
const _hoisted_34 = {
  class: "px-3 py-2.5 text-center"
};
const _hoisted_35 = ["onUpdate:modelValue"];
const _hoisted_36 = {
  class: "px-3 py-2.5"
};
const _hoisted_37 = ["onUpdate:modelValue"];
const _hoisted_38 = {
  class: "px-3 py-2.5"
};
const _hoisted_39 = ["onUpdate:modelValue"];
const _hoisted_40 = {
  class: "data-table-sticky-right data-table-sticky-action px-3 py-2.5 text-right"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  key: 0,
  class: "mt-3 text-sm text-red-600"
};
const _hoisted_43 = {
  class: "flex flex-col-reverse gap-3 border-t border-slate-200 px-4 py-4 sm:flex-row sm:justify-end sm:px-5"
};
const _hoisted_44 = ["disabled"];
const _hoisted_45 = ["disabled"];
import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { PlusIcon, TrashIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import AppModal from '@/components/AppModal.vue';
import { formatInvoiceAmount, formatProfitRate } from '../utils';
import { useWheelToHorizontalScroll } from '../composables/useWheelToHorizontalScroll';
import { allocationsForCustomer, downstreamDraftSummary, downstreamTargetInputAvailability, selectableDownstreamCustomers } from '../downstreamRules.mjs';
import { displayInvoiceCompanyName } from '../matrixRules.mjs';
export default {
  __name: 'InvoiceDownstreamAllocationDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: null
    },
    customers: {
      type: Array,
      default: () => []
    },
    allocations: {
      type: Array,
      default: () => []
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const rows = ref([]);
    const targetKeyword = ref('');
    const allocationTableScrollRef = useWheelToHorizontalScroll();
    let nextLocalId = 1;
    const companyName = computed(() => props.customer ? displayInvoiceCompanyName(props.customer) : '-');
    const targetAmount = computed(() => Number(props.customer?.targetOutputAmount || 0));
    const targetOptions = computed(() => selectableDownstreamCustomers(props.customers, props.customer?.id));
    const filteredTargetOptions = computed(() => {
      const keyword = targetKeyword.value.trim().toLowerCase();
      if (!keyword) return targetOptions.value;
      return targetOptions.value.filter(customer => {
        const text = [customer.label, customer.regionName, customer.registeredRegionSnapshot, customer.registeredRegion].filter(Boolean).join(' ').toLowerCase();
        return text.includes(keyword);
      });
    });
    const summary = computed(() => downstreamDraftSummary(rows.value, props.customer));
    const totalAmount = computed(() => summary.value.totalAmount);
    const remainingAmount = computed(() => summary.value.remainingAmount);
    const enabledCount = computed(() => summary.value.enabledCount);
    const overAllocated = computed(() => summary.value.overAllocated);
    function resetRows() {
      targetKeyword.value = '';
      const source = allocationsForCustomer(props.allocations, props.customer?.id);
      rows.value = source.map((item, index) => ({
        localId: nextLocalId++,
        toPlanCustomerId: item.toPlanCustomerId,
        amount: item.amount ?? null,
        enabled: item.enabled !== false,
        displayOrder: item.displayOrder || index + 1,
        remark: item.remark || ''
      }));
    }
    function addRow() {
      rows.value.push({
        localId: nextLocalId++,
        toPlanCustomerId: null,
        amount: null,
        enabled: true,
        displayOrder: rows.value.length + 1,
        remark: ''
      });
    }
    function removeRow(index) {
      rows.value.splice(index, 1);
    }
    function isTargetUsed(targetId, ignoreIndex) {
      return rows.value.some((row, index) => index !== ignoreIndex && row.toPlanCustomerId != null && String(row.toPlanCustomerId) === String(targetId));
    }
    function selectedTarget(targetId) {
      if (targetId === null || targetId === undefined || targetId === '') return null;
      return targetOptions.value.find(customer => String(customer.id) === String(targetId)) || null;
    }
    function targetInputAvailability(targetId, rowIndex) {
      return downstreamTargetInputAvailability({
        target: selectedTarget(targetId),
        savedAllocations: props.allocations,
        draftRows: rows.value,
        editingFromPlanCustomerId: props.customer?.id ?? props.customer?.planCustomerId,
        currentRowIndex: rowIndex
      });
    }
    function rowInputOverAvailable(row, rowIndex) {
      if (!row || row.enabled === false || !row.toPlanCustomerId) return false;
      const amount = Number(row.amount);
      if (!Number.isFinite(amount) || amount <= 0) return false;
      return amount > targetInputAvailability(row.toPlanCustomerId, rowIndex).remainingAmount;
    }
    function filterTargetOptions(keyword = '') {
      targetKeyword.value = keyword;
    }
    function close() {
      emit('update:modelValue', false);
    }
    function submit() {
      const normalized = [];
      const seen = new Set();
      for (const [index, row] of rows.value.entries()) {
        if (!row.toPlanCustomerId) {
          ElMessage.warning(`第 ${index + 1} 行请选择下游客户`);
          return;
        }
        if (seen.has(String(row.toPlanCustomerId))) {
          ElMessage.warning('下游客户不能重复');
          return;
        }
        seen.add(String(row.toPlanCustomerId));
        const amount = Number(row.amount);
        if (!Number.isFinite(amount) || amount <= 0) {
          ElMessage.warning(`第 ${index + 1} 行金额必须大于 0`);
          return;
        }
        normalized.push({
          toPlanCustomerId: row.toPlanCustomerId,
          amount,
          enabled: row.enabled !== false,
          displayOrder: Number(row.displayOrder || index + 1),
          remark: String(row.remark || '').trim() || null
        });
      }
      if (overAllocated.value) {
        ElMessage.warning('已指定金额不能超过目标销项额度');
        return;
      }
      emit('submit', {
        customer: props.customer,
        allocations: normalized
      });
    }
    watch(() => props.modelValue, value => {
      if (value) resetRows();
    });
    watch(() => [props.customer?.id, props.allocations], () => {
      if (props.modelValue) resetRows();
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "6xl",
        "z-index": 80,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "指定下游", -1)), _createElementVNode("p", _hoisted_4, _toDisplayString(companyName.value) + " · 指定金额是边金额，也是下游进项金额。 ", 1)]), _createElementVNode("button", {
          type: "button",
          class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
          onClick: close
        }, [_cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "sr-only"
        }, "关闭", -1)), _createVNode(_unref(XMarkIcon), {
          class: "h-5 w-5"
        })])])]), _createElementVNode("main", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "目标销项", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatInvoiceAmount)(targetAmount.value)), 1)]), _createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "已指定", -1)), _createElementVNode("div", {
          class: _normalizeClass(["mt-1 text-base font-semibold", overAllocated.value ? 'text-red-600' : 'text-slate-900'])
        }, _toDisplayString(_unref(formatInvoiceAmount)(totalAmount.value)), 3)]), _createElementVNode("div", _hoisted_10, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "剩余自动生成", -1)), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(formatInvoiceAmount)(remainingAmount.value)), 1)]), _createElementVNode("div", _hoisted_12, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "配置数", -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(enabledCount.value) + " / " + _toDisplayString(rows.value.length), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("label", _hoisted_16, [_cache[7] || (_cache[7] = _createElementVNode("span", {
          class: "sr-only"
        }, "搜索下游客户", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => targetKeyword.value = $event),
          type: "search",
          class: "form-search-input form-control-sm w-full",
          placeholder: "搜索公司、区域"
        }, null, 512), [[_vModelText, targetKeyword.value]])])]), _createElementVNode("div", {
          ref_key: "allocationTableScrollRef",
          ref: allocationTableScrollRef,
          class: "overflow-x-auto"
        }, [_createElementVNode("table", _hoisted_17, [_cache[9] || (_cache[9] = _createElementVNode("thead", {
          class: "bg-slate-50 text-left text-xs font-semibold text-slate-500"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-sticky-left data-table-sticky-head data-table-sticky-identity px-3 py-2.5"
        }, "下游客户"), _createElementVNode("th", {
          class: "w-28 px-3 py-2.5"
        }, "名单区域"), _createElementVNode("th", {
          class: "w-36 px-3 py-2.5 text-right"
        }, "指定金额"), _createElementVNode("th", {
          class: "w-24 px-3 py-2.5 text-center"
        }, "启用"), _createElementVNode("th", {
          class: "w-24 px-3 py-2.5 text-right"
        }, "排序"), _createElementVNode("th", {
          class: "px-3 py-2.5"
        }, "备注"), _createElementVNode("th", {
          class: "data-table-sticky-right data-table-sticky-head data-table-sticky-action w-16 px-3 py-2.5 text-right"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_18, [rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [...(_cache[8] || (_cache[8] = [_createElementVNode("td", {
          colspan: "7",
          class: "px-3 py-8 text-center text-slate-500"
        }, "暂无指定下游", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, index) => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.localId
          }, [_createElementVNode("td", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_select, {
            modelValue: row.toPlanCustomerId,
            "onUpdate:modelValue": $event => row.toPlanCustomerId = $event,
            class: "form-select form-control-sm w-full",
            filterable: "",
            "filter-method": filterTargetOptions,
            "popper-class": "enterprise-invoice-downstream-select",
            placeholder: "选择下游客户"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTargetOptions.value, customer => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: customer.id,
                label: customer.label,
                value: customer.id,
                disabled: isTargetUsed(customer.id, index)
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(customer.label), 1), _createElementVNode("span", _hoisted_24, _toDisplayString(customer.regionName || customer.registeredRegionSnapshot || '未分组'), 1), _createElementVNode("span", _hoisted_25, "销 " + _toDisplayString(_unref(formatInvoiceAmount)(customer.targetOutputAmount)), 1), _createElementVNode("span", _hoisted_26, "进 " + _toDisplayString(_unref(formatInvoiceAmount)(customer.targetInputAmount)), 1), _createElementVNode("span", _hoisted_27, "余 " + _toDisplayString(_unref(formatInvoiceAmount)(targetInputAvailability(customer.id, index).remainingAmount)), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(formatProfitRate)(customer.targetProfitRate)), 1)])]),
                _: 2
              }, 1032, ["label", "value", "disabled"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"]), selectedTarget(row.toPlanCustomerId) ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("span", null, "目标销项 " + _toDisplayString(_unref(formatInvoiceAmount)(selectedTarget(row.toPlanCustomerId).targetOutputAmount)), 1), _createElementVNode("span", null, "目标进项 " + _toDisplayString(_unref(formatInvoiceAmount)(selectedTarget(row.toPlanCustomerId).targetInputAmount)), 1), _createElementVNode("span", {
            class: _normalizeClass(rowInputOverAvailable(row, index) ? 'font-medium text-red-600' : 'text-blue-600')
          }, " 剩余进项 " + _toDisplayString(_unref(formatInvoiceAmount)(targetInputAvailability(row.toPlanCustomerId, index).remainingAmount)), 3), _createElementVNode("span", null, "利润率 " + _toDisplayString(_unref(formatProfitRate)(selectedTarget(row.toPlanCustomerId).targetProfitRate)), 1)])) : _createCommentVNode("", true), rowInputOverAvailable(row, index) ? (_openBlock(), _createElementBlock("p", _hoisted_30, " 指定金额超过该下游剩余可分配进项，保存时后端会拒绝。 ")) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_31, _toDisplayString(selectedTarget(row.toPlanCustomerId)?.regionName || selectedTarget(row.toPlanCustomerId)?.registeredRegionSnapshot || '-'), 1), _createElementVNode("td", _hoisted_32, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => row.amount = $event,
            type: "number",
            min: "0",
            step: "100",
            class: "form-input form-control-sm w-full text-right tabular-nums",
            placeholder: "0"
          }, null, 8, _hoisted_33), [[_vModelText, row.amount]])]), _createElementVNode("td", _hoisted_34, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => row.enabled = $event,
            type: "checkbox",
            class: "form-check"
          }, null, 8, _hoisted_35), [[_vModelCheckbox, row.enabled]])]), _createElementVNode("td", _hoisted_36, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => row.displayOrder = $event,
            type: "number",
            min: "1",
            step: "1",
            class: "form-input form-control-sm w-full text-right tabular-nums"
          }, null, 8, _hoisted_37), [[_vModelText, row.displayOrder, void 0, {
            number: true
          }]])]), _createElementVNode("td", _hoisted_38, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => row.remark = $event,
            type: "text",
            maxlength: "255",
            class: "form-input form-control-sm w-full",
            placeholder: "可选"
          }, null, 8, _hoisted_39), [[_vModelText, row.remark]])]), _createElementVNode("td", _hoisted_40, [_withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => removeRow(index)
          }, [_createVNode(_unref(TrashIcon), {
            class: "h-3.5 w-3.5"
          })], 8, _hoisted_41)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']])])]);
        }), 128))])])], 512)]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-secondary mt-3 inline-flex w-full items-center justify-center gap-1.5 sm:w-auto",
          onClick: addRow
        }, [_createVNode(_unref(PlusIcon), {
          class: "h-4 w-4"
        }), _cache[10] || (_cache[10] = _createTextVNode(" 新增下游 ", -1))])), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']]), overAllocated.value ? (_openBlock(), _createElementBlock("p", _hoisted_42, "已指定金额超过目标销项额度，请调整后再保存。")) : _createCommentVNode("", true)]), _createElementVNode("footer", _hoisted_43, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary w-full sm:w-auto",
          disabled: __props.submitting,
          onClick: close
        }, "取消", 8, _hoisted_44), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-primary w-full sm:w-auto",
          disabled: __props.submitting,
          onClick: submit
        }, [_createTextVNode(_toDisplayString(__props.submitting ? '保存中...' : '保存指定下游'), 1)], 8, _hoisted_45)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']])])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};